import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  id: "demo",
  class: "intro-subsection"
}
const _hoisted_2 = { class: "intro-content" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", { class: "intro-title" }, "Découvrez toutes les fonctionnalités de Florisuite", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "intro-description" }, " Optimisez votre gestion florale avec une suite complète d'outils intelligents et intuitifs. Chaque fonctionnalité est conçue pour simplifier votre quotidien et booster votre croissance. ", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "intro-button-text" }, "Voir la Démo", -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  class: "modal",
  role: "dialog",
  "aria-modal": "true",
  "aria-label": "Démo Florisuite"
}
const _hoisted_8 = { class: "video-wrapper" }
const _hoisted_9 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("button", {
        class: "intro-button",
        type: "button",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openDemo && _ctx.openDemo(...args)))
      }, _hoisted_6)
    ]),
    (_ctx.isOpen)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "modal-overlay",
          onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeDemo && _ctx.closeDemo(...args)), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("button", {
              class: "modal-close",
              type: "button",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeDemo && _ctx.closeDemo(...args))),
              "aria-label": "Fermer"
            }, " ✕ "),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("video", {
                ref: "demoVideo",
                class: "video",
                src: _ctx.demoVideoUrl,
                controls: "",
                autoplay: "",
                muted: "",
                preload: "metadata",
                playsinline: "",
                title: "Démo Florisuite",
                onError: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleVideoError && _ctx.handleVideoError(...args)))
              }, " Votre navigateur ne supporte pas la lecture de vidéos HTML5. ", 40, _hoisted_9)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}